module.exports = __webpack_public_path__ + "static/media/checklist-black.a0ee4400.svg";